import { AdminAuditTrail } from "@/features/admin/audit-trail";

export default function AdminAuditLogPage() {
  return <AdminAuditTrail />;
}
